// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const getUsageApiAiUsageGetParamsMonthOneMax = 7;

export const getUsageApiAiUsageGetParamsYearOneMax = 4;

export const GetUsageApiAiUsageGetParams = zod.object({
  "month": zod.union([zod.string().max(getUsageApiAiUsageGetParamsMonthOneMax),zod.null()]).optional(),
  "year": zod.union([zod.string().max(getUsageApiAiUsageGetParamsYearOneMax),zod.null()]).optional()
})

export type GetUsageApiAiUsageGetParams = zod.input<typeof GetUsageApiAiUsageGetParams>;
export type GetUsageApiAiUsageGetParamsOutput = zod.output<typeof GetUsageApiAiUsageGetParams>;
